import { isoToDateTimeString } from "utils/date";

export default [

  { field: 'eventAt', headerAlign: 'center', headerName: 'Дата и время', minWidth: 120, flex:1,
    valueGetter: (value) => isoToDateTimeString(value)},

  { field: 'user', flex: 1, headerAlign: 'center', headerName: 'Пользователь', align: 'center' },

  { field: 'event', flex: 3, headerAlign: 'center', headerName: 'Действие', align: 'right' }

];      